<template>
  <Background
    :id="sectionId"
    :theme="theme?.background"
  >
    <Padding :padding="theme?.padding">
      <slot />
    </Padding>
  </Background>
</template>

<script lang="ts" setup>
import Background from '~/components/Atmos/Background/Background.vue';
import Padding from '~/components/Atmos/Padding/Padding.vue';
import type { GeneralTheme } from '~/sanity/types';
const props = defineProps<{ theme?: GeneralTheme }>();
const sectionId = computed(() => props.theme?.sectionId);
</script>

<style scoped></style>
